import { Flex, FlexProps, Heading, HeadingProps, HStack } from "@chakra-ui/react";
import { ReactNode } from "react";

export const listHeaderRow = { borderBottom: "1px solid", borderColor: "smBorder", px: "2", py: "2.5" } satisfies FlexProps;

export const ListPageHeader = ({
  heading,
  headingColor,
  actions,
  ...flexProps
}: {
  heading: ReactNode;
  headingColor?: HeadingProps["color"];
  actions: ReactNode;
} & Omit<FlexProps, "children" | "direction" | "align" | "justify">) => (
  <Flex
    direction={{ base: "column", sm: "row" }}
    align={{ base: "flex-start", sm: "center" }}
    justify="space-between"
    gap="3"
    {...flexProps}
  >
    <Heading as="h1" size="lg" color={headingColor} minW="0" overflowWrap="anywhere">
      {heading}
    </Heading>
    <HStack spacing="2" flexShrink={0}>
      {actions}
    </HStack>
  </Flex>
);
